import { AlertType } from '@/models';
import { RiskKeys } from '@/config/riskSignals';
import { CompRiskLevel, Direction } from '@/api';
import { OptionAlertType } from '@/components/_inputs/InputSelect/components/OptionAlert/OptionAlert';

export const alertGradeOptions: OptionAlertType[] = [
  { value: 'low' },
  { value: 'medium' },
  { value: 'high' },
  { value: 'severe' },
];

export const alertGradePriority: Record<AlertType | CompRiskLevel, number> = {
  na: 0,
  low: 1,
  medium: 2,
  high: 3,
  severe: 4,
};

export const alertGrades: AlertType[] = ['low', 'medium', 'high', 'severe'];

export const transactionAlertsDefaultValue: TransactionAlertsEditValue = {
  category: null,
  alertGrade: null,
  direction: null,
  direct: null,
  indirect: null,
};

export type DirectionOption = {
  label: string;
  value: Direction;
};

export type TransactionAlertsEditValue = {
  category: RiskKeys | null;
  alertGrade: AlertType | CompRiskLevel | null;
  direction: Direction | null;
  direct: number | null;
  indirect: number | null;
};
